import { ChangeDetectorRef } from '@angular/core';
import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

declare var echarts;
declare var ecStat;

@Component({
  selector: 'app-echart',
  templateUrl: './echart.component.html',
  styleUrls: ['./echart.component.scss']
})
export class EchartComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() option: Observable<any> = null;
  @Input() height: string;
  @Input() regression: boolean = false;
  public loading: boolean = true;
  @ViewChild('main') main: ElementRef;
  private chart: any = null;
  private optionSubcription: Subscription;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    setTimeout(()=>{
      if(this.chart){
        this.chart.resize({
          width: 'auto'
        });
      }
    },1000);
  }
  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.optionSubcription = this.option.subscribe((opt)=>{
      if(opt && typeof(opt) !== 'string'){
        this.loading = false;
        this.cd.detectChanges();
        this.initChart(opt);
      } else {
        this.loading = true;
        this.cd.detectChanges();
      }
    });
  }

  ngOnDestroy(){
    if(this.optionSubcription){
      this.optionSubcription.unsubscribe();
    }
  }

  initChart(options){
    this.chart = echarts.init(this.main.nativeElement, {}, {
      devicePixelRatio: window.devicePixelRatio,
      width: 'auto'
    });

    if(this.regression){
      echarts.registerTransform(ecStat.transform.regression);
    }

    this.chart.setOption(options);
    setTimeout(() => {
      this.chart.resize({
        width: 'auto'
      });
    }, 1000);
  }

}
